<div class="full-width-image-container">
  <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>

<div class="top">
  <div>Do The <span>Right Thing</span></div>
  <div>On Point <span>With Safety</span></div>
  <div>Roll up <span>Your Sleeves</span></div>
</div>
<hr class="hr">
<br><br><br>

<div class="container">
    <h1>Fort Worth</h1>
    <h2>Residence Inn by Marriott Fort Worth Southwest</h2>
    <p>
        There is a corporate rate available to Landpoint employees traveling to Fort Worth for business. To utilize our rate choose one of the three options below:
    </p>
    <div class="inner">
          <ol>
            <li>
              Call the hotel directly, 817-731-5400. When booking your room tell them you’re with Landpoint and we have a corporate rate.
            </li>
            <li>
              Click the link below to book online: <br>
              <a mat-raised-button href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1773845663977&key=CORP&app=resvlink" target="_blank" color="primary">View Form</a><br><br>
            </li>
            <li>
              When booking your room via the app enter the corporate code listed below. Then search for Residence Inn Fort Worth Southwest. Once the hotel is selected you will see “Landpoint Corporate Rate”. Continue with your booking as usual.
              <br>
              <strong>Code: S6598</strong>
            </li>
          </ol>
    </div>
    <div class="map-container">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3356.9083960989687!2d-97.41212908516262!3d32.686305780988594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e721fefbf10ad%3A0x8b10a8a735fb44b8!2s5825%20Arborlawn%20Dr%2C%20Fort%20Worth%2C%20TX%2076109!5e0!3m2!1sen!2sus!4v1620076025498!5m2!1sen!2sus" 
        width="600" 
        height="450" 
        style="border:0;" 
        allowfullscreen="" 
        loading="lazy">
      </iframe>
    </div>
    <br><br>
    <hr class="hr-two">

    <h1>Houston</h1>
    <h2>Embassy Suites by Hilton</h2>
    <p>
        16435 Katy Fwy. Houston, TX 77094
    </p>
    <div class="map-container">
        <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3462.7848877762904!2d-95.67051502319985!3d29.7838610308681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640d9155debf3e1%3A0x7a600c069827fce4!2s16435%20Katy%20Fwy%2C%20Houston%2C%20TX%2077094!5e0!3m2!1sen!2sus!4v1722930010429!5m2!1sen!2sus"
            width="600" 
            height="450" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy">
        </iframe>
    </div>

    <br><br>
    <hr class="hr-two">

    <h1>Austin</h1>
    <h2>Aloft Hotels</h2>
    <p>
        2951 Jazz St. Round Rock, TX 78664
        <br>
        <strong>Code: S6598</strong>
    </p>
    <div class="map-container">
        <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3438.3420499390713!2d-97.6567524231853!3d30.48306889765356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644cfd4c7ffed77%3A0x93077ab1586eefa6!2s2951%20Jazz%20St%2C%20Round%20Rock%2C%20TX%2078664!5e0!3m2!1sen!2sus!4v1722930235549!5m2!1sen!2sus"
            width="600" 
            height="450" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy">
        </iframe>
    </div>
    <br><br>
    <hr class="hr-two">

    <h1>Bossier</h1>
    <p>(No Corporate Rate; below listed hotels near office)</p>
    <h2>Hampton Inn & Suites</h2>
    <p>
        2691 Viking Dr, Bossier City, LA 71111
    </p>
    <div class="map-container">
        <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3362.8860232834195!2d-93.7103070231398!3d32.55588699525196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8631337406bfb167%3A0x11690b8e78692b35!2s2691%20Viking%20Dr%2C%20Bossier%20City%2C%20LA%2071111!5e0!3m2!1sen!2sus!4v1722930347155!5m2!1sen!2sus"
            width="600" 
            height="450" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy">
        </iframe>
    </div>
    <br>
    <h2>Resident Inn By Marriott</h2>
    <p>501 Traffic St, Bossier City, LA 71111</p>
    <div class="map-container">
        <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3364.355306115995!2d-93.73934132314069!3d32.51665619724404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x863132d1db4ab3ab%3A0xc754e2b05604c657!2s501%20Traffic%20St%2C%20Bossier%20City%2C%20LA%2071111!5e0!3m2!1sen!2sus!4v1722930423753!5m2!1sen!2sus"
            width="600" 
            height="450" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy">
        </iframe>
    </div>
</div>
